import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { IConsumptionHistory } from '@mwe/models';
import { EnvironmentService } from '../../environment/environment.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountInfoService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  private resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/accountinfo/';
  }

  getConsumptionHistory(accountNumber: string, systemId: string): Promise<IConsumptionHistory> {
    return lastValueFrom(
      this.http.get<IConsumptionHistory>(this.resourceUrl + accountNumber + '/consumption/history?systemId=' + systemId),
    );
  }
}
